import { Link } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';

const WhatIsHardwoodFlooring = () => {
  return (
    <div className={styles['article-page']}>
      <div className={styles.page}>
        <header className={styles['article-header']}>
          <SiteTopNav variant="light" />
        </header>

        <main className={styles['article-main']}>
          <Link className={styles['article-back']} to="/academy/hardwood-basics">
            ← Back to Flooring 101
          </Link>

          <p className={styles['article-eyebrow']} data-motion="copy">
            Sakura Floors Academy
          </p>
          <h1 className={styles['article-title']} data-motion="hero">
            What Is Engineered Hardwood?
          </h1>
          <p className={styles['article-intro']} data-motion="copy">
            Engineered hardwood flooring combines the beauty of real wood with modern engineering.
            It features a genuine hardwood wear layer bonded to multiple layers of premium plywood,
            creating a floor that is more dimensionally stable than solid hardwood while maintaining
            the natural character of real wood.
          </p>
          <p className={styles['article-intro']} data-motion="copy">
            Because of its multi-layer construction, engineered hardwood is designed to better
            withstand seasonal changes in temperature and humidity. It can be installed in a wider
            range of environments, including over concrete subfloors, on-grade or below-grade
            spaces, and many radiant heating systems, making it one of the most versatile premium
            flooring options available.
          </p>
          <p className={styles['article-intro']} data-motion="copy">
            Whether you're renovating a home or designing a commercial space, engineered hardwood
            offers the timeless warmth of natural wood with enhanced performance for modern living.
          </p>

          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Wear Layer</h2>
            <p className={styles['article-section__text']}>
              The wear layer is the top layer of real hardwood that gives engineered flooring its
              authentic appearance. A thicker wear layer generally provides greater longevity and
              may allow the floor to be refinished multiple times over its lifespan.
            </p>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Core Construction</h2>
            <p className={styles['article-section__text']}>
              Beneath the hardwood veneer are multiple layers of high-quality plywood arranged in
              alternating grain directions. This cross-layer construction minimizes expansion and
              contraction, providing excellent stability in changing climates.
            </p>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Thickness</h2>
            <p className={styles['article-section__text']}>
              Engineered hardwood is available in several overall thicknesses, commonly 1/2", 5/8",
              and 3/4". Thicker products often provide a more substantial feel underfoot and can
              support a thicker wear layer.
            </p>
          </section>

          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Plank Width</h2>
            <p className={styles['article-section__text']}>
              Wide planks create a clean, contemporary appearance that showcases the natural beauty
              of wood. Narrower planks offer a more traditional aesthetic. Today's premium
              engineered flooring is commonly available in widths ranging from 5" to 10" or more.
            </p>
          </section>
          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Plank Length</h2>
            <p className={styles['article-section__text']}>
              Long planks reduce the number of end joints, creating a more seamless and luxurious
              installation. Premium collections often feature random lengths with a high percentage
              of extra-long boards for a sophisticated look.
            </p>
          </section>
          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Wood Species</h2>
            <p className={styles['article-section__text']}>
              The wood species used for the wear layer determines both the appearance and durability
              of the floor. White oak remains the most popular choice due to its attractive grain,
              versatility, and excellent hardness, while species such as ash, walnut, maple, and
              hickory each offer their own unique character.
            </p>
          </section>
          <section className={styles['article-section']} data-motion="section">
            <h2 className={styles['article-section__title']}>Surface Texture & Finish</h2>
            <p className={styles['article-section__text']}>
              Engineered hardwood is available in a variety of surface textures, including smooth,
              wire-brushed, hand-scraped, and distressed finishes. Modern UV-cured finishes provide
              exceptional resistance to everyday wear while highlighting the natural beauty of the
              wood.
            </p>
          </section>
        </main>
      </div>
    </div>
  );
};

export default WhatIsHardwoodFlooring;
